import React, { useState } from 'react';

export const Select = ({ data, className, handleChangeSelect, defaultValue, multiple, 
    id }) => {

    const [ valueSelect, setValueSelect ] = useState(defaultValue ? defaultValue : undefined);
    className = className ? className : "";

    const handleValue = (e) => {
        if(e?.target?.value){
            setValueSelect(e.target.value);
        }
        handleChangeSelect?.(e);
    }

    const options = data?.map((item, index) => {
            item.className = item.className ? item.className : "";
            return (
                <option key={`op${index}`} id={item.id} value={item.value}
                    className={`option-input-simple ${item.className}`}
                    data-object={item.data? JSON.stringify(item.data) : ""}>
                    {item.label}
                </option>
            );

    }
        );

    const select  = <select
        id={id}
        className={`select-input-simple ${className}`}
        value={valueSelect}
        multiple={multiple}
        onChange={(e) => {
            handleValue(e);
        }}>
        {options}
    </select>;

    return (
        select
    );

}